import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { Button } from '../../../../../../components/Button'
import { ButtonColumn, ButtonRow, Heading2, ModalContainer, Text } from '../../../../../../components/layout'
import { SelectInput } from '../../../../../../components/layout/form/input'
import { Styling } from '../../../../../../components/Styling'
import { repairShopOptions, useRepairShops } from './options'
import { Maybe } from '../../../../../../common/types'
import SkeletonLoader from '../../../../../../components/AlArcCodesForm'
import { routeSubformMessages } from '../messages'

interface RepairShopProps {
  onCancel: () => void
  onResetShop: () => void
  onSetShop: (shopId: Maybe<string>) => void
  repairShopId?: Maybe<string>
  serviceChannel: Maybe<string> // AL.serviceChannel
}

// ^ get AL.serviceChannel from parent

export const RepairShopModal: React.FunctionComponent<RepairShopProps> = ({
  onCancel,
  onResetShop,
  onSetShop,
  repairShopId = null,
  serviceChannel = null,
}) => {
  const intl = useIntl()
  const [selectedShop, setSelectedShop] = useState<string | null>(repairShopId)

  const { loading, repairShops } = useRepairShops()
  const updateSelectedShop = (value: string | number | undefined | null) => {
    if (value) {
      setSelectedShop(value.toString())
    } else {
      setSelectedShop(null)
    }
  }
  return (
    <ModalContainer>
      <Modal>
        <ModalRow>
          <Heading2>{intl.formatMessage(routeSubformMessages.changeRepairShopModalTitle)}</Heading2>
          <Styling color="red" bold>
            <Text>{intl.formatMessage(routeSubformMessages.changeRepairShopModalWarning)}</Text>
          </Styling>
        </ModalRow>
        <ModalRow>
         {loading ? (
            <SkeletonLoader width="100%" height="38px" text={intl.formatMessage(routeSubformMessages.loadingRepairShop)} />
          ) : (
            <SelectInput
              label={intl.formatMessage(routeSubformMessages.selectNewRepairShop)}
              name="automobileAndTouringClubFinland.repairShopId"
              onChange={updateSelectedShop}
              options={repairShopOptions(repairShops, serviceChannel, repairShopId)}
              clearable
            />
          )}
        </ModalRow>
        <ModalButtonRow>
          <ButtonColumn>
            <Button
              label={intl.formatMessage(routeSubformMessages.selectRepairShop)}
              category="save"
              disabled={!selectedShop}
              onClick={() => onSetShop(selectedShop)}
            />
          </ButtonColumn>
          <ButtonColumn>
            <Button label={intl.formatMessage(routeSubformMessages.otherAddress)} category="clear" onClick={onResetShop} />
          </ButtonColumn>
          <ButtonColumn>
            <Button label={intl.formatMessage(routeSubformMessages.cancel)} category="cancel" onClick={onCancel} />
          </ButtonColumn>
        </ModalButtonRow>
      </Modal>
    </ModalContainer>
  )
}

const ModalButtonRow = styled(ButtonRow as any)`
  justify-content: center;
`

const Modal = styled.div`
  text-align: center;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.white};
  padding: 1rem;
  max-width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ModalRow = styled.div`
  width: 100%;
  max-width: ${props => props.theme.screenSize.mobile};
  margin-top: 1rem;
  margin-bottom: 1rem;
`
